// extracted by mini-css-extract-plugin
module.exports = {"container":"bX","logo":"bY","mainPanel":"bZ"};